// export const myGetter = ( state ) => {
//  return state
// }

export const getTenants = (state) => {
  return state.tenants
}

export const getCurrentTenant = (state) => {
  return state.currentTenant
}

export const isLoading = (state) => {
  return state.loading
}